export default {
  available: 'Available',
  inProgress: 'In Progress',
  completed: 'Completed',
}
